<template>
<div class="chapter">
<div class="inner_page">
<p class="end-title_1"><span>PRAISE FOR THE WRITING OF PATRICIA POTTER</span></p>
<p class="normal1">“Patricia Potter is a master storyteller, a powerful weaver of romantic tales.” —Mary Jo Putney, <i>New York Times</i>–bestselling author</p>
<p class="normal1">“One of the romance genre’s finest talents.” —<i>Romantic Times</i></p>
<p class="normal1">“Patricia Potter will thrill lovers of the suspense genre as well as those who enjoy a good romance.” <i>—Booklist</i></p>
<p class="normal1">“Potter proves herself a gifted writer as artisan, creating a rich fabric of strong characters whose wit and intellect will enthrall even as their adventures entertain.” —<i>BookPage</i></p>
<p class="normal1">“When a historical romance [gets] the Potter treatment, the story line is pure action and excitement, and the characters are wonderful.” <i>—BookBrowse</i></p>
<p class="normal1">“Potter has an expert ability to invest in fully realized characters and a strong sense of place without losing momentum in the details, making this novel a pure pleasure.” —<i>Publishers Weekly</i>, starred review of <i>Beloved Warrior</i></p>
<p class="normal1">“[Potter] proves that she’s adept at penning both enthralling historicals and captivating contemporary novels.” <i>—Booklist</i>, starred review of <i>Dancing with a Rogue</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// endmatter02.vue?88367854